import styles from "./ClientKpiCards.module.scss";

function ClientKpiCards({ stats }) {
  const {
    totalAppointments = 0,
    averageBasket = 0,
    totalRevenue = 0,
    lastAppointmentDate = null,
  } = stats || {};

  const formattedLastVisit = lastAppointmentDate
    ? new Date(lastAppointmentDate).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : "Aucune visite";

  // Tag simple basé sur des seuils, à ajuster selon ton activité
  const getClientTag = () => {
    if (totalAppointments === 0) return null;
    if (totalRevenue >= 500)
      return { label: "Gros spendeur", color: "#c9a227" };
    if (totalAppointments >= 6)
      return { label: "Fidèle", color: "var(--primary-color)" };

    if (lastAppointmentDate) {
      const daysSinceLastVisit =
        (Date.now() - new Date(lastAppointmentDate).getTime()) /
        (1000 * 60 * 60 * 24);
      if (daysSinceLastVisit > 90) {
        return { label: "À relancer", color: "#c0392b" };
      }
    }
    return null;
  };

  const tag = getClientTag();

  return (
    <div className={styles.kpiSection}>
      <div className={styles.kpiCard}>
        <h3>Nombre de RDV</h3>
        <p className={styles.kpiValue}>{totalAppointments}</p>
      </div>

      <div className={styles.kpiCard}>
        <h3>Panier moyen</h3>
        <p className={styles.kpiValue}>{averageBasket.toFixed(2)} €</p>
      </div>

      <div className={styles.kpiCard}>
        <h3>CA total généré</h3>
        <p className={styles.kpiValue}>{totalRevenue.toFixed(2)} €</p>
      </div>

      <div className={styles.kpiCard}>
        <h3>Dernier RDV</h3>
        <p className={styles.kpiValue}>{formattedLastVisit}</p>
      </div>

      {tag && (
        <div className={styles.kpiCard}>
          <h3>Statut client</h3>
          <p className={styles.kpiTag} style={{ backgroundColor: tag.color }}>
            {tag.label}
          </p>
        </div>
      )}
    </div>
  );
}

export default ClientKpiCards;
